module.exports = __webpack_public_path__ + "static/img/t2.c466479e.jpg";